import type { CurrentUser } from "../domains/user/hooks/useCurrentUser";

export const isInternalRoom = (
  currentUser: CurrentUser | null,
  _roomId: string
) => {
  void currentUser;
  // CurrentUser (api) does not expose internal.room — always false for now.
  // Kept for GA analytics event compatibility.
  return false;
};
